const S = {
  wrapper: { marginTop:'10px', padding:'40px', border:'3px solid grey', fontFamily:"'Georgia', serif", color:'#1a1a2e', lineHeight:'1.7' },
  h1: { fontSize:'2rem', fontWeight:'700', borderBottom:'3px solid #c0392b', paddingBottom:'8px', marginBottom:'24px', color:'#7B0D0D' },
  h2: { fontSize:'1.3rem', fontWeight:'700', color:'#c0392b', marginTop:'36px', marginBottom:'12px', borderLeft:'4px solid #c0392b', paddingLeft:'10px' },
  p: { marginBottom:'12px', fontSize:'0.97rem' },
  infoBox: { background:'#FEF0F0', border:'2px solid #c0392b', borderRadius:'6px', padding:'16px 20px', margin:'16px 0' },
  infoBoxTitle: { fontWeight:'700', fontFamily:"'Courier New', monospace", fontSize:'0.88rem', color:'#7B0D0D', marginBottom:'8px' },
  infoBoxItem: { fontSize:'0.9rem', margin:'4px 0', paddingLeft:'12px', borderLeft:'2px solid #c0392b' },
  table: { width:'100%', borderCollapse:'collapse', marginBottom:'20px', fontSize:'0.92rem' },
  th: { background:'#c0392b', color:'#fff', padding:'10px 14px', textAlign:'left', fontWeight:'700', fontSize:'0.9rem' },
  tdE: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff5f5' },
  tdO: { padding:'10px 14px', borderBottom:'1px solid #f0cece', verticalAlign:'top', background:'#fff' },
  tdL: { fontWeight:'600', color:'#7B0D0D', whiteSpace:'nowrap', width:'220px' },
  code: { fontFamily:"'Courier New', monospace", fontSize:'0.88rem', whiteSpace:'pre-wrap' },
  dWrap: { margin:'24px 0', background:'#fffafa', border:'1px solid #f0cece', borderRadius:'8px', padding:'20px' },
  dTitle: { fontWeight:'700', fontSize:'0.95rem', color:'#7B0D0D', marginBottom:'12px', textAlign:'center', letterSpacing:'0.02em' },
  dCaption: { fontSize:'0.84rem', color:'#555', textAlign:'center', marginTop:'10px', fontStyle:'italic' },
};

function InfoBox({ title, items }) {
  return (
    <div style={S.infoBox}>
      <div style={S.infoBoxTitle}>{title}</div>
      {items.map((item, i) => <div key={i} style={S.infoBoxItem}>{item}</div>)}
    </div>
  );
}

function Table2({ rows }) {
  return (
    <table style={S.table}>
      <thead><tr>
        <th style={{ ...S.th, width:'220px' }}>Concept</th>
        <th style={S.th}>Explanation / Formula</th>
      </tr></thead>
      <tbody>
        {rows.map(([label, content], i) => (
          <tr key={i}>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.tdL }}>{label}</td>
            <td style={{ ...(i%2===0?S.tdE:S.tdO), ...S.code }}>{content}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

// ── Diagram 1: Spectrophotometer Setup ────────────────────────────
function DiagramSpectrophotometer() {
  const W = 860, H = 320;
  // Spectrum gradient colours for the light beam
  const specColors = ['#c0392b','#e67e22','#f1c40f','#27ae60','#2E75B6','#8e44ad'];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Spectrophotometer — Light Path from Source to Detector</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aK" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#333" />
          </marker>
          <marker id="aW" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#fff" />
          </marker>
          <linearGradient id="specGrad" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%"   stopColor="#c0392b" />
            <stop offset="20%"  stopColor="#e67e22" />
            <stop offset="40%"  stopColor="#f1c40f" />
            <stop offset="60%"  stopColor="#27ae60" />
            <stop offset="80%"  stopColor="#2E75B6" />
            <stop offset="100%" stopColor="#8e44ad" />
          </linearGradient>
          <linearGradient id="beamFade" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%"   stopColor="#f1c40f" stopOpacity="1" />
            <stop offset="100%" stopColor="#f1c40f" stopOpacity="0.25" />
          </linearGradient>
        </defs>

        {/* ── Light Source ── */}
        <ellipse cx={80} cy={155} rx={45} ry={60} fill="url(#specGrad)" stroke="#555" strokeWidth="1.5" />
        <text x={80} y={240} textAnchor="middle" fontSize="11" fontWeight="700" fill="#333">Light</text>
        <text x={80} y={254} textAnchor="middle" fontSize="11" fontWeight="700" fill="#333">Source</text>

        {/* White beam from source */}
        <rect x={126} y={145} width={60} height={20} fill="#f5f5dc" opacity="0.9" />

        {/* ── Monochromator / Filter ── */}
        <ellipse cx={220} cy={155} rx={30} ry={48} fill="#6c2d8a" stroke="#4a1a6a" strokeWidth="2" />
        <text x={220} y={222} textAnchor="middle" fontSize="11" fontWeight="700" fill="#333">Filter /</text>
        <text x={220} y={236} textAnchor="middle" fontSize="11" fontWeight="700" fill="#333">Monochromator</text>

        {/* Single-wavelength beam (yellow-green example) */}
        <rect x={251} y={148} width={130} height={14} fill="#27ae60" opacity="0.7" />

        {/* I₀ label with arrow */}
        <line x1={285} y1={130} x2={285} y2={147} stroke="#333" strokeWidth="1.5" markerEnd="url(#aK)" />
        <text x={285} y={122} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">I₀</text>
        <text x={285} y={112} textAnchor="middle" fontSize="9" fill="#555">(incident)</text>

        {/* ── Cuvette / Sample ── */}
        <rect x={382} y={118} width={60} height={74} rx={4} fill="#d6eaf8" stroke="#2E75B6" strokeWidth="2" opacity="0.85" />
        {/* sample tint */}
        <rect x={382} y={118} width={60} height={74} rx={4} fill="#27ae60" opacity="0.2" />
        <text x={412} y={210} textAnchor="middle" fontSize="11" fontWeight="700" fill="#2E75B6">Cuvette</text>
        <text x={412} y={224} textAnchor="middle" fontSize="11" fontWeight="700" fill="#2E75B6">(Sample)</text>
        <text x={412} y={134} textAnchor="middle" fontSize="9" fill="#2E75B6">path length l</text>

        {/* Attenuated beam after sample */}
        <rect x={443} y={148} width={130} height={14} fill="#27ae60" opacity="0.25" />

        {/* I label */}
        <line x1={508} y1={130} x2={508} y2={147} stroke="#333" strokeWidth="1.5" markerEnd="url(#aK)" />
        <text x={508} y={122} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e">I</text>
        <text x={508} y={112} textAnchor="middle" fontSize="9" fill="#555">(transmitted)</text>

        {/* ── Detector ── */}
        <rect x={574} y={122} width={68} height={66} rx={6} fill="#555" stroke="#333" strokeWidth="2" />
        <rect x={580} y={128} width={56} height={54} rx={4} fill="#2c3e50" />
        {/* detector screen lines */}
        {[135,142,149,156,163,170].map((y,i) => (
          <line key={i} x1={584} y1={y} x2={630} y2={y} stroke="#27ae60" strokeWidth="1" opacity="0.6" />
        ))}
        <text x={608} y={207} textAnchor="middle" fontSize="11" fontWeight="700" fill="#333">Detector</text>

        {/* ── Readout box ── */}
        <rect x={660} y={105} width={185} height={100} rx={6} fill="#fff" stroke="#c0392b" strokeWidth="2" />
        <text x={752} y={127} textAnchor="middle" fontSize="11" fontWeight="700" fill="#7B0D0D">Readout</text>
        <text x={752} y={148} textAnchor="middle" fontSize="12" fontFamily="'Courier New',monospace" fill="#1a1a2e">T = I / I₀</text>
        <text x={752} y={168} textAnchor="middle" fontSize="12" fontFamily="'Courier New',monospace" fill="#c0392b">A = −log₁₀(T)</text>
        <text x={752} y={186} textAnchor="middle" fontSize="10" fill="#555">A = εcl  (Beer-Lambert)</text>
        {/* arrow from detector to readout */}
        <line x1={643} y1={155} x2={659} y2={155} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aK)" />

        {/* Bottom label arrows */}
        {[
          [80,'Light\nSource'],[220,'Filter'],[412,'Medium\n(Cuvette)'],[608,'Detector']
        ].map(([x,lbl],i) => (
          <g key={i}>
            <line x1={x} y1={270} x2={x} y2={260} stroke="#555" strokeWidth="1.5" markerEnd="url(#aK)" />
          </g>
        ))}
      </svg>
      <div style={S.dCaption}>
        In a spectrophotometer, a broadband source is filtered to a single wavelength, passed through a sample of known path length, and the transmitted intensity measured. Absorbance is calculated from the ratio of transmitted to incident intensity.
      </div>
    </div>
  );
}

// ── Diagram 2: Beer-Lambert Law — graphical ───────────────────────
function DiagramBeerLambert() {
  const W = 860, H = 360;

  // Left: A vs concentration (linear)
  const absPts = [];
  for (let c = 0; c <= 200; c += 5) {
    absPts.push(`${80 + c * 1.7},${280 - c * 0.9}`);
  }

  // Right: Transmittance vs concentration (exponential decay)
  const transPts = [];
  for (let c = 0; c <= 200; c += 3) {
    const T = Math.exp(-c * 0.012) * 100;
    transPts.push(`${520 + c * 1.7},${280 - T * 1.6}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Beer-Lambert Law — Absorbance vs Concentration (Linear) and Transmittance vs Concentration (Exponential)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="axArr" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* ── Left: A vs c ── */}
        <rect x={20} y={15} width={400} height={320} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={220} y={38} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Absorbance vs Concentration</text>

        {/* Axes */}
        <line x1={80} y1={50} x2={80} y2={290} stroke="#555" strokeWidth="1.5" markerEnd="url(#axArr)" />
        <line x1={70} y1={280} x2={400} y2={280} stroke="#555" strokeWidth="1.5" markerEnd="url(#axArr)" />
        <text x={76} y={46} fontSize="10" textAnchor="end" fill="#555">A</text>
        <text x={402} y={285} fontSize="10" fill="#555">c</text>

        {/* Linear region */}
        <path d={'M ' + absPts.slice(0,30).join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.5" />
        {/* Deviation at high c */}
        <path d={'M ' + absPts.slice(28).map((pt, i) => {
          const [x, y] = pt.split(',').map(Number);
          return `${x},${y + i * 0.8}`;
        }).join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2.5" strokeDasharray="7,3" />

        {/* Labels */}
        <text x={200} y={155} fontSize="10" fill="#2E75B6" fontWeight="700">Linear region</text>
        <text x={200} y={168} fontSize="10" fill="#2E75B6">(A = εcl)</text>
        <text x={300} y={200} fontSize="10" fill="#c0392b" fontWeight="700">Deviation at</text>
        <text x={300} y={213} fontSize="10" fill="#c0392b">high c</text>

        {/* Slope annotation */}
        <line x1={80} y1={280} x2={180} y2={280} stroke="#27ae60" strokeWidth="1.2" />
        <line x1={180} y1={280} x2={180} y2={190} stroke="#27ae60" strokeWidth="1.2" />
        <text x={130} y={296} textAnchor="middle" fontSize="9" fill="#27ae60">Δc</text>
        <text x={192} y={238} fontSize="9" fill="#27ae60">ΔA</text>
        <text x={100} y={310} fontSize="9" fill="#27ae60">slope = εl</text>

        {/* ── Right: T vs c ── */}
        <rect x={440} y={15} width={400} height={320} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={640} y={38} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Transmittance vs Concentration</text>

        {/* Axes */}
        <line x1={520} y1={50} x2={520} y2={290} stroke="#555" strokeWidth="1.5" markerEnd="url(#axArr)" />
        <line x1={510} y1={280} x2={820} y2={280} stroke="#555" strokeWidth="1.5" markerEnd="url(#axArr)" />
        <text x={516} y={46} fontSize="10" textAnchor="end" fill="#555">T(%)</text>
        <text x={822} y={285} fontSize="10" fill="#555">c</text>

        {/* 100% line */}
        <line x1={520} y1={120} x2={820} y2={120} stroke="#ddd" strokeWidth="1" strokeDasharray="4,3" />
        <text x={516} y={124} fontSize="9" textAnchor="end" fill="#aaa">100%</text>

        {/* Exponential curve */}
        <path d={'M ' + transPts.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2.5" />
        {/* Fill under curve */}
        <path d={'M 520,280 L ' + transPts.join(' L ') + ' L 860,280 Z'} fill="#c0392b" opacity="0.06" />

        {/* Half-life annotation */}
        <line x1={520} y1={200} x2={617} y2={200} stroke="#e67e22" strokeWidth="1.2" strokeDasharray="4,3" />
        <line x1={617} y1={200} x2={617} y2={280} stroke="#e67e22" strokeWidth="1.2" strokeDasharray="4,3" />
        <text x={568} y={195} textAnchor="middle" fontSize="9" fill="#e67e22">T = 50%</text>
        <text x={617} y={296} textAnchor="middle" fontSize="9" fill="#e67e22">c½</text>

        <text x={700} y={200} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">T = 10^(−εcl)</text>
        <text x={700} y={215} textAnchor="middle" fontSize="10" fill="#c0392b">Exponential decay</text>
        <text x={700} y={230} textAnchor="middle" fontSize="10" fill="#555">Non-linear in c</text>
      </svg>
      <div style={S.dCaption}>
        Absorbance has a linear relationship with concentration — this is why it is preferred over transmittance for quantitative analysis. Transmittance decreases exponentially with concentration, making it unsuitable for direct calibration plots.
      </div>
    </div>
  );
}

// ── Diagram 3: Absorbance Spectrum ────────────────────────────────
function DiagramAbsorptionSpectrum() {
  const W = 860, H = 320;

  // Simulated absorption spectrum with two peaks (like chlorophyll)
  function spectrumY(lambda) {
    const p1 = 60 * Math.exp(-Math.pow(lambda - 430, 2) / (2 * 18 * 18));
    const p2 = 80 * Math.exp(-Math.pow(lambda - 670, 2) / (2 * 22 * 22));
    const p3 = 25 * Math.exp(-Math.pow(lambda - 500, 2) / (2 * 30 * 30));
    return p1 + p2 + p3;
  }

  const specPts = [];
  for (let lam = 380; lam <= 750; lam += 3) {
    const x = 60 + (lam - 380) / (750 - 380) * 720;
    const y = 260 - spectrumY(lam) * 2.2;
    specPts.push(`${x},${y}`);
  }

  // Colour bands along x-axis
  const bands = [
    { lam0:380, lam1:450, fill:'#8e44ad' },
    { lam0:450, lam1:495, fill:'#2E75B6' },
    { lam0:495, lam1:530, fill:'#27ae60' },
    { lam0:530, lam1:590, fill:'#f1c40f' },
    { lam0:590, lam1:625, fill:'#e67e22' },
    { lam0:625, lam1:750, fill:'#c0392b' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Absorption Spectrum — Absorbance vs Wavelength (Example: Chlorophyll-like molecule)</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="axA" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* Wavelength colour bands */}
        {bands.map((b, i) => {
          const x1 = 60 + (b.lam0 - 380) / 370 * 720;
          const x2 = 60 + (b.lam1 - 380) / 370 * 720;
          return (
            <rect key={i} x={x1} y={265} width={x2 - x1} height={22} fill={b.fill} opacity="0.7" />
          );
        })}

        {/* Axes */}
        <line x1={60} y1={30} x2={60} y2={270} stroke="#555" strokeWidth="1.5" markerEnd="url(#axA)" />
        <line x1={50} y1={260} x2={795} y2={260} stroke="#555" strokeWidth="1.5" markerEnd="url(#axA)" />
        <text x={56} y={28} fontSize="10" textAnchor="end" fill="#555">A</text>
        <text x={797} y={265} fontSize="10" fill="#555">λ (nm)</text>

        {/* Gridlines and wavelength labels */}
        {[400,450,500,550,600,650,700,750].map(lam => {
          const x = 60 + (lam - 380) / 370 * 720;
          return (
            <g key={lam}>
              <line x1={x} y1={258} x2={x} y2={268} stroke="#555" strokeWidth="1" />
              <text x={x} y={280} textAnchor="middle" fontSize="9" fill="#555">{lam}</text>
            </g>
          );
        })}

        {/* A axis ticks */}
        {[0.5,1.0,1.5,2.0].map((a, i) => {
          const y = 260 - a * 88;
          return (
            <g key={i}>
              <line x1={58} y1={y} x2={68} y2={y} stroke="#555" strokeWidth="1" />
              <text x={54} y={y+4} textAnchor="end" fontSize="9" fill="#555">{a.toFixed(1)}</text>
              <line x1={68} y1={y} x2={790} y2={y} stroke="#eee" strokeWidth="1" />
            </g>
          );
        })}

        {/* Spectrum curve filled */}
        <path d={'M 60,260 L ' + specPts.join(' L ') + ' L 780,260 Z'} fill="#2E75B6" opacity="0.12" />
        <path d={'M ' + specPts.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.5" />

        {/* Peak annotations */}
        <line x1={175} y1={80} x2={175} y2={118} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3" />
        <text x={175} y={74} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">λ_max = 430 nm</text>
        <text x={175} y={62} textAnchor="middle" fontSize="9" fill="#c0392b">(Soret / violet peak)</text>

        <line x1={663} y1={60} x2={663} y2={80} stroke="#c0392b" strokeWidth="1.5" strokeDasharray="5,3" />
        <text x={663} y={54} textAnchor="middle" fontSize="10" fill="#c0392b" fontWeight="700">λ_max = 670 nm</text>
        <text x={663} y={42} textAnchor="middle" fontSize="9" fill="#c0392b">(Red peak)</text>

        {/* Green gap label */}
        <text x={430} y={218} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">Green transmitted</text>
        <text x={430} y={231} textAnchor="middle" fontSize="9" fill="#27ae60">(low absorbance → leaves appear green)</text>

        {/* Colour region labels */}
        {['Violet','Blue','Green','Yellow','Orange','Red'].map((lbl, i) => {
          const x = [397, 449, 499, 546, 594, 648][i];
          return (
            <text key={i} x={x} y={292} textAnchor="middle" fontSize="8" fill="#fff" fontWeight="700">{lbl}</text>
          );
        })}
      </svg>
      <div style={S.dCaption}>
        The absorption spectrum plots absorbance against wavelength. Peaks correspond to wavelengths where photons are most efficiently absorbed. The wavelength of maximum absorbance (λ_max) is used for analytical measurements to maximise sensitivity.
      </div>
    </div>
  );
}

// ── Diagram 4: Light–Matter Interaction at the atomic level ───────
function DiagramPhotonAbsorption() {
  const W = 860, H = 300;
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Photon Absorption — Electronic Transitions and Energy Levels</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aUp" markerWidth="8" markerHeight="8" refX="4" refY="6" orient="auto">
            <polygon points="0 7,4 0,8 7" fill="#c0392b" />
          </marker>
          <marker id="aDn" markerWidth="8" markerHeight="8" refX="4" refY="2" orient="auto">
            <polygon points="0 0,4 7,8 0" fill="#27ae60" />
          </marker>
          <marker id="aRt" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#e6a817" />
          </marker>
        </defs>

        {/* ── Absorption panel ── */}
        <rect x={15} y={15} width={250} height={270} rx={8} fill="#fff5f5" stroke="#c0392b" strokeWidth="1.5" />
        <text x={140} y={36} textAnchor="middle" fontSize="12" fontWeight="700" fill="#c0392b">Absorption</text>

        {/* Energy levels */}
        <line x1={50} y1={220} x2={220} y2={220} stroke="#333" strokeWidth="2" />
        <line x1={50} y1={130} x2={220} y2={130} stroke="#333" strokeWidth="2" />
        <line x1={50} y1={70}  x2={220} y2={70}  stroke="#aaa" strokeWidth="1.5" strokeDasharray="5,3" />
        <text x={228} y={224} fontSize="10" fill="#333">E₀ (ground)</text>
        <text x={228} y={134} fontSize="10" fill="#333">E₁ (excited)</text>
        <text x={228} y={74}  fontSize="10" fill="#aaa">E₂</text>

        {/* Electron dot ground */}
        <circle cx={130} cy={220} r={8} fill="#c0392b" />
        {/* Photon incoming */}
        {[0,1,2,3,4].map(i => (
          <line key={i} x1={55+i*10} y1={175-i*4} x2={65+i*10} y2={183-i*4}
            stroke="#f1c40f" strokeWidth="2" />
        ))}
        <line x1={50} y1={178} x2={110} y2={178} stroke="#f1c40f" strokeWidth="1.5" markerEnd="url(#aRt)" />
        <text x={80} y={166} textAnchor="middle" fontSize="10" fill="#f1c40f" fontWeight="700">photon  hf</text>
        {/* Transition arrow */}
        <line x1={130} y1={212} x2={130} y2={138} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aUp)" />
        {/* ΔE label */}
        <text x={136} y={180} fontSize="11" fill="#c0392b" fontWeight="700">ΔE = hf</text>

        {/* ── Spontaneous Emission ── */}
        <rect x={290} y={15} width={250} height={270} rx={8} fill="#f0fff4" stroke="#27ae60" strokeWidth="1.5} " />
        <text x={415} y={36} textAnchor="middle" fontSize="12" fontWeight="700" fill="#27ae60">Spontaneous Emission</text>

        <line x1={325} y1={220} x2={545} y2={220} stroke="#333" strokeWidth="2" />
        <line x1={325} y1={130} x2={545} y2={130} stroke="#333" strokeWidth="2" />
        <text x={550} y={224} fontSize="10" fill="#333">E₀</text>
        <text x={550} y={134} fontSize="10" fill="#333">E₁</text>

        {/* Electron excited */}
        <circle cx={435} cy={130} r={8} fill="#27ae60" />
        {/* Transition down */}
        <line x1={435} y1={138} x2={435} y2={212} stroke="#27ae60" strokeWidth="2" markerEnd="url(#aDn)" />
        <text x={442} y={180} fontSize="11" fill="#27ae60" fontWeight="700">ΔE = hf</text>
        {/* Emitted photon */}
        {[0,1,2,3,4].map(i => (
          <line key={i} x1={460+i*12} y1={175+i*4} x2={472+i*12} y2={167+i*4}
            stroke="#f1c40f" strokeWidth="2" />
        ))}
        <line x1={455} y1={178} x2={540} y2={178} stroke="#f1c40f" strokeWidth="1.5" markerEnd="url(#aRt)" />
        <text x={508} y={168} textAnchor="middle" fontSize="10" fill="#f1c40f" fontWeight="700">emitted photon</text>
        <text x={415} y={260} textAnchor="middle" fontSize="9" fill="#555" fontStyle="italic">Random direction; basis of fluorescence</text>

        {/* ── Vibrational/Rotational ── */}
        <rect x={565} y={15} width={280} height={270} rx={8} fill="#eaf3ff" stroke="#2E75B6" strokeWidth="1.5" />
        <text x={705} y={36} textAnchor="middle" fontSize="12" fontWeight="700" fill="#2E75B6">Energy Level Ladder</text>

        {/* Multiple vibrational sub-levels */}
        {[220,190,162,136,112,90,70].map((y, i) => (
          <g key={i}>
            <line x1={590} y1={y} x2={830} y2={y} stroke={i===0 ? '#333':'#888'} strokeWidth={i===0?2:1.2}
              strokeDasharray={i > 3 ? '5,3' : 'none'} />
            <text x={836} y={y+4} fontSize="9" fill={i > 3 ? '#aaa':'#333'}>v={i}</text>
          </g>
        ))}
        <text x={575} y={240} fontSize="9" fill="#2E75B6" transform="rotate(-90 575 175)">Energy</text>
        {/* Arrows showing different transitions */}
        <line x1={640} y1={218} x2={640} y2={94} stroke="#c0392b" strokeWidth="2" markerEnd="url(#aUp)" />
        <text x={648} y={155} fontSize="9" fill="#c0392b">UV/Vis</text>
        <line x1={680} y1={218} x2={680} y2={160} stroke="#e67e22" strokeWidth="2" markerEnd="url(#aUp)" />
        <text x={688} y={195} fontSize="9" fill="#e67e22">Near-IR</text>
        <line x1={720} y1={218} x2={720} y2={190} stroke="#2E75B6" strokeWidth="2" markerEnd="url(#aUp)" />
        <text x={728} y={208} fontSize="9" fill="#2E75B6">Far-IR</text>
        <text x={705} y={272} textAnchor="middle" fontSize="9" fill="#555" fontStyle="italic">Vibrational (IR) and electronic (UV/Vis) transitions</text>
      </svg>
      <div style={S.dCaption}>
        Absorption occurs when a photon's energy exactly matches the energy gap between two levels: ΔE = hf. Electronic transitions (UV/Vis), vibrational transitions (IR), and rotational transitions (microwave) each absorb at characteristic frequencies — the basis of spectroscopy.
      </div>
    </div>
  );
}

// ── Diagram 5: Transmittance vs Absorbance scale ──────────────────
function DiagramTAScale() {
  const W = 860, H = 260;
  const pairs = [
    { T:100, A:0.000, label:'100%', col:'#27ae60' },
    { T:50,  A:0.301, label:'50%',  col:'#2E75B6' },
    { T:25,  A:0.602, label:'25%',  col:'#2E75B6' },
    { T:10,  A:1.000, label:'10%',  col:'#e67e22' },
    { T:1,   A:2.000, label:'1%',   col:'#e67e22' },
    { T:0.1, A:3.000, label:'0.1%', col:'#c0392b' },
  ];

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Transmittance ↔ Absorbance Conversion — Logarithmic Relationship</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>

        {/* Top bar: transmittance gradient */}
        <defs>
          <linearGradient id="tGrad" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%"   stopColor="#c0392b" stopOpacity="0.9" />
            <stop offset="50%"  stopColor="#e67e22" stopOpacity="0.7" />
            <stop offset="100%" stopColor="#27ae60" stopOpacity="0.5" />
          </linearGradient>
        </defs>

        {/* Absorbance scale bar (left = high, right = low) */}
        <rect x={60} y={40} width={740} height={28} rx={4} fill="url(#tGrad)" />
        <text x={40} y={60} textAnchor="end" fontSize="10" fill="#555" fontWeight="700">A</text>

        {/* Transmittance scale bar (inverted) */}
        <defs>
          <linearGradient id="tGrad2" x1="0" x2="1" y1="0" y2="0">
            <stop offset="0%"   stopColor="#27ae60" stopOpacity="0.5" />
            <stop offset="100%" stopColor="#c0392b" stopOpacity="0.9" />
          </linearGradient>
        </defs>
        <rect x={60} y={130} width={740} height={28} rx={4} fill="url(#tGrad2)" />
        <text x={40} y={150} textAnchor="end" fontSize="10" fill="#555" fontWeight="700">T%</text>

        {/* Tick marks and labels for each pair */}
        {pairs.map((p, i) => {
          // A scale: 0 at right (x=800), 3 at left (x=60)
          const xA = 800 - (p.A / 3) * 740;
          // T scale: 100% at left (x=60), 0.1% at right (x=800)  -- log scale
          const xT = 60 + (1 - Math.log10(p.T + 0.001) / Math.log10(100.001)) * 740;
          // simple linear for T: T 100→0 left to right
          const xTlin = 60 + (1 - p.T / 100) * 740;

          return (
            <g key={i}>
              {/* A scale tick */}
              <line x1={xA} y1={38} x2={xA} y2={72} stroke="#fff" strokeWidth="1.5" />
              <text x={xA} y={34} textAnchor="middle" fontSize="10" fill={p.col} fontWeight="700">{p.A.toFixed(2)}</text>

              {/* T scale tick */}
              <line x1={xA} y1={128} x2={xA} y2={162} stroke="#fff" strokeWidth="1.5" />
              <text x={xA} y={175} textAnchor="middle" fontSize="10" fill={p.col} fontWeight="700">{p.label}</text>

              {/* Connecting dashed line */}
              <line x1={xA} y1={72} x2={xA} y2={128} stroke={p.col} strokeWidth="1.2" strokeDasharray="4,3" />
            </g>
          );
        })}

        {/* Scale direction labels */}
        <text x={60} y={26} fontSize="10" fill="#c0392b" fontWeight="700">← High absorbance</text>
        <text x={700} y={26} fontSize="10" fill="#27ae60" fontWeight="700">Low absorbance →</text>
        <text x={60} y={195} fontSize="10" fill="#27ae60" fontWeight="700">High transmittance →</text>
        <text x={680} y={195} fontSize="10" fill="#c0392b" fontWeight="700">← Low transmittance</text>

        {/* Formula */}
        <rect x={270} y={205} width={320} height={46} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.5" />
        <text x={430} y={225} textAnchor="middle" fontSize="12" fontWeight="700" fill="#1a1a2e" fontFamily="'Courier New',monospace">A = −log₁₀(T) = log₁₀(I₀/I)</text>
        <text x={430} y={242} textAnchor="middle" fontSize="10" fill="#555">T = I/I₀  (transmittance, 0–1 or 0–100%)</text>
      </svg>
      <div style={S.dCaption}>
        Transmittance and absorbance are inversely related on a logarithmic scale. A = 1 corresponds to 10% transmission (90% absorbed); A = 2 to 1% transmission; A = 3 to 0.1% transmission. Each unit increase in A represents a 10-fold reduction in transmitted light.
      </div>
    </div>
  );
}

// ── Diagram 6: Path Length Effect ────────────────────────────────
function DiagramPathLength() {
  const W = 860, H = 280;
  const cuvettes = [
    { l:10, label:'l = 1 cm',  A:0.40, T:40, col:'#27ae60' },
    { l:20, label:'l = 2 cm',  A:0.80, T:16, col:'#f1c40f' },
    { l:30, label:'l = 3 cm',  A:1.20, T:6,  col:'#e67e22' },
    { l:40, label:'l = 4 cm',  A:1.60, T:2.5,col:'#c0392b' },
  ];
  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Effect of Path Length — Longer Path = Higher Absorbance at Same Concentration</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="aRt2" markerWidth="8" markerHeight="8" refX="6" refY="3.5" orient="auto">
            <polygon points="0 0,7 3.5,0 7" fill="#e6a817" />
          </marker>
        </defs>

        {/* Incident beam label */}
        <text x={40} y={105} fontSize="11" fontWeight="700" fill="#333">I₀</text>
        <text x={40} y={120} fontSize="9" fill="#555">(same for all)</text>

        {cuvettes.map((cv, i) => {
          const startX = 90 + i * 190;
          const cuvetteW = cv.l * 1.8;
          const beamW = Math.max(2, cv.T / 3);
          const beamY = 120 - beamW / 2;

          return (
            <g key={i}>
              {/* Incident beam */}
              <rect x={startX} y={110} width={30} height={20} fill="#f1c40f" opacity="0.8" />
              {/* Cuvette */}
              <rect x={startX + 30} y={85} width={cuvetteW} height={70} rx={3}
                fill={cv.col} stroke="#555" strokeWidth="1.5" opacity="0.3" />
              <rect x={startX + 30} y={85} width={cuvetteW} height={70} rx={3}
                fill="none" stroke="#555" strokeWidth="1.5" />
              {/* Transmitted beam (thinner/darker) */}
              <rect x={startX + 30 + cuvetteW} y={110} width={28} height={20}
                fill="#f1c40f" opacity={cv.T / 100} />
              {/* Transmitted beam arrow */}
              <line x1={startX + 30 + cuvetteW + 29} y1={120}
                x2={startX + 30 + cuvetteW + 38} y2={120}
                stroke="#e6a817" strokeWidth="2" markerEnd="url(#aRt2)" />

              {/* Labels below */}
              <text x={startX + 30 + cuvetteW / 2} y={170} textAnchor="middle" fontSize="10" fontWeight="700" fill="#333">{cv.label}</text>
              <text x={startX + 30 + cuvetteW / 2} y={185} textAnchor="middle" fontSize="10" fill="#c0392b">A = {cv.A.toFixed(2)}</text>
              <text x={startX + 30 + cuvetteW / 2} y={200} textAnchor="middle" fontSize="10" fill="#2E75B6">T = {cv.T}%</text>

              {/* Sample molecules dots */}
              {Array.from({ length: Math.round(cv.l / 2) }).map((_, mi) => {
                const mx = startX + 38 + mi * (cuvetteW / (cv.l / 2 + 1));
                return <circle key={mi} cx={mx} cy={120} r={4} fill={cv.col} opacity="0.5" />;
              })}
            </g>
          );
        })}

        {/* Formula reminder */}
        <rect x={20} y={218} width={820} height={44} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.2} " />
        <text x={430} y={237} textAnchor="middle" fontSize="11" fontWeight="700" fill="#1a1a2e" fontFamily="'Courier New',monospace">Beer-Lambert:  A = ε × c × l</text>
        <text x={430} y={254} textAnchor="middle" fontSize="10" fill="#555">ε = molar attenuation coefficient (L mol⁻¹ cm⁻¹),  c = molar concentration (mol L⁻¹),  l = path length (cm)</text>
      </svg>
      <div style={S.dCaption}>
        Doubling the path length doubles the absorbance (at constant concentration). This is the physical basis of the l term in Beer-Lambert: A = εcl. Standard cuvettes have l = 1 cm, making A numerically equal to εc.
      </div>
    </div>
  );
}

// ── Diagram 7: Deviations from Beer-Lambert ───────────────────────
function DiagramDeviations() {
  const W = 860, H = 300;

  // Ideal line
  const idealPts = [];
  for (let c = 0; c <= 100; c += 5) {
    idealPts.push(`${80 + c * 7},${260 - c * 2.0}`);
  }
  // Positive deviation (association)
  const posPts = [];
  for (let c = 0; c <= 100; c += 5) {
    const a = c * 0.02 + Math.pow(c / 80, 2.5) * 1.8;
    posPts.push(`${80 + c * 7},${260 - a * 100}`);
  }
  // Negative deviation (saturation)
  const negPts = [];
  for (let c = 0; c <= 100; c += 5) {
    const a = c * 0.02 * (1 - c / 350);
    negPts.push(`${80 + c * 7},${260 - Math.max(0, a) * 100}`);
  }

  return (
    <div style={S.dWrap}>
      <div style={S.dTitle}>Deviations from Beer-Lambert Law — Positive and Negative Deviations</div>
      <svg viewBox={`0 0 ${W} ${H}`} style={{ width:'100%', display:'block' }}>
        <defs>
          <marker id="axD" markerWidth="7" markerHeight="7" refX="5" refY="3.5" orient="auto">
            <polygon points="0 0,6 3.5,0 7" fill="#555" />
          </marker>
        </defs>

        {/* Axes */}
        <line x1={80} y1={30} x2={80} y2={270} stroke="#555" strokeWidth="1.5" markerEnd="url(#axD)" />
        <line x1={70} y1={260} x2={790} y2={260} stroke="#555" strokeWidth="1.5" markerEnd="url(#axD)" />
        <text x={76} y={28} fontSize="10" textAnchor="end" fill="#555">A</text>
        <text x={792} y={265} fontSize="10" fill="#555">Concentration (c)</text>

        {/* Linear range shading */}
        <rect x={80} y={60} width={210} height={200} fill="#27ae60" opacity="0.06" />
        <text x={185} y={50} textAnchor="middle" fontSize="10" fill="#27ae60" fontWeight="700">Linear range</text>

        {/* Ideal Beer-Lambert line */}
        <path d={'M ' + idealPts.join(' L ')} fill="none" stroke="#555" strokeWidth="2" strokeDasharray="8,4" />
        <text x={766} y={62} fontSize="10" fill="#555">Ideal</text>

        {/* Positive deviation */}
        <path d={'M ' + posPts.join(' L ')} fill="none" stroke="#c0392b" strokeWidth="2.2" />
        <text x={600} y={50} fontSize="10" fill="#c0392b" fontWeight="700">Positive deviation</text>
        <text x={600} y={64} fontSize="9" fill="#c0392b">(association, stray light)</text>

        {/* Negative deviation */}
        <path d={'M ' + negPts.join(' L ')} fill="none" stroke="#2E75B6" strokeWidth="2.2" />
        <text x={500} y={200} fontSize="10" fill="#2E75B6" fontWeight="700">Negative deviation</text>
        <text x={500} y={214} fontSize="9" fill="#2E75B6">(sample saturation, dissociation)</text>

        {/* Deviation causes box */}
        <rect x={420} y={25} width={430} height={110} rx={5} fill="#fff" stroke="#c0392b" strokeWidth="1.2} " />
        <text x={635} y={44} textAnchor="middle" fontSize="10" fontWeight="700" fill="#7B0D0D">Causes of Deviation</text>
        <text x={432} y={60} fontSize="9" fill="#333">Positive: stray light, fluorescence, polychromatic light, solute association</text>
        <text x={432} y={74} fontSize="9" fill="#333">Negative: sample saturation, high concentration (ionic interaction),</text>
        <text x={432} y={88} fontSize="9" fill="#333">  refractive index change, solute dissociation at low c</text>
        <text x={432} y={104} fontSize="9" fill="#333">Chemical: equilibria shifting with c (e.g. pH-sensitive indicators)</text>
        <text x={432} y={118} fontSize="9" fill="#333">Instrumental: detector non-linearity, bandwidth too wide vs absorption peak</text>
      </svg>
      <div style={S.dCaption}>
        Beer-Lambert is an ideal law valid only at low concentrations, with monochromatic light, and in homogeneous solutions. Both instrument artefacts and genuine chemical interactions cause the calibration curve to deviate from linearity.
      </div>
    </div>
  );
}

export default function LightAbsorbance() {
  return (
    <div style={S.wrapper}>
      <h1 style={S.h1}>Light Absorbance</h1>

      <p style={S.p}>
        Light absorbance occurs when photons transfer their energy into atoms and molecules, promoting electrons from lower to higher energy states. As light travels through an absorbing medium, its intensity decreases exponentially — a consequence of each successive thin layer of the material removing the same <em>fraction</em> of the remaining light. This exponential attenuation is encoded in the <strong>Beer-Lambert Law</strong>, one of the most widely used relationships in analytical science and physics.
      </p>
      <p style={S.p}>
        The Beer-Lambert Law states that absorbance is directly proportional to both the concentration of the absorbing species and the length of the path through which light travels. It provides the physical basis for <strong>spectrophotometry</strong> — the quantitative measurement of how much light a sample absorbs at each wavelength, enabling the identification and concentration determination of countless chemical species from pharmaceuticals to environmental pollutants.
      </p>
      <p style={S.p}>
        Absorbance is a dimensionless quantity measured in absorbance units (AU). Because it is logarithmically related to transmitted intensity, each unit increase in absorbance represents a tenfold reduction in transmitted light: 1 AU corresponds to 10% transmission, 2 AU to 1%, and 3 AU to 0.1%. In practice, measurements are most reliable in the range 0.1–1.5 AU, where the relationship between absorbance and concentration remains linear.
      </p>

      <InfoBox title="What This Page Covers" items={[
        "The Beer-Lambert Law: derivation, terms and conditions of validity",
        "Transmittance, absorbance and their logarithmic relationship",
        "The molar attenuation (extinction) coefficient ε",
        "Spectrophotometer: components, light path, and measurement principle",
        "Absorption spectra: λ_max, chromophores, and chromophore systems",
        "Electronic, vibrational and rotational transitions",
        "Effect of concentration and path length on absorbance",
        "Deviations from Beer-Lambert: chemical and instrumental causes",
        "Calibration curves: construction, linearity, and error analysis",
        "Applications: colorimetry, UV-Vis, IR, atomic absorption, fluorescence",
        "Stray light, scattering, and sources of measurement error",
        "Turbidity, optical density, and related measures",
      ]}/>

      <h2 style={S.h2}>The Spectrophotometer</h2>
      <p style={S.p}>
        A <strong>spectrophotometer</strong> is the instrument used to measure light absorbance. It consists of a broadband light source, a means of selecting a narrow wavelength band (a monochromator or filter), a sample holder (usually a transparent cuvette), and a detector that measures the intensity of transmitted light. The ratio of transmitted to incident intensity gives the transmittance, from which absorbance is calculated.
      </p>
      <DiagramSpectrophotometer/>
      <Table2 rows={[
        ["Light source","Tungsten-halogen lamp for visible (350–900 nm); deuterium lamp for UV (190–400 nm)\nXenon flash lamps used in modern instruments covering both ranges simultaneously"],
        ["Monochromator","Diffraction grating or prism disperses white light; adjustable slit selects narrow band\nBandwidth (spectral slit width) typically 1–5 nm; narrower = more accurate but less light"],
        ["Cuvette (cell)","Transparent container holding the sample; standard path length = 1 cm\nGlass: visible range only; quartz: UV + visible; plastic: disposable, visible only"],
        ["Reference beam","Double-beam instruments split light; one path through sample, one through blank (solvent)\nAutomatic compensation for source fluctuations and solvent absorption"],
        ["Detector","Photomultiplier tube (PMT): high sensitivity for low light levels\nPhotodiode array: records full spectrum simultaneously — modern instruments"],
        ["Blank (reference)","Measurement taken with solvent only; sets I₀ (100%T, 0 absorbance)\nEliminates solvent absorption and cuvette reflection from sample reading"],
        ["Dark current","Detector signal with no light: subtracted from all readings\nSets true zero; important at low light levels or high absorbance samples"],
        ["Microplate reader","96/384-well plate version of spectrophotometer; reads many samples simultaneously\nPath length depends on liquid volume; requires path-length correction for Beer-Lambert"],
      ]}/>

      <h2 style={S.h2}>The Beer-Lambert Law</h2>
      <p style={S.p}>
        The <strong>Beer-Lambert Law</strong> (also called the Beer-Lambert-Bouguer Law) combines two independent observations: <strong>Bouguer's Law</strong> (1729) showing that absorbance is proportional to path length, and <strong>Beer's Law</strong> (1852) showing that absorbance is proportional to concentration. Together they produce the cornerstone equation of quantitative spectroscopy.
      </p>
      <DiagramBeerLambert/>
      <Table2 rows={[
        ["Beer-Lambert Law","A = ε × c × l\nA = absorbance (dimensionless, AU)\nε = molar attenuation coefficient (L mol⁻¹ cm⁻¹)\nc = molar concentration (mol L⁻¹ or M)\nl = optical path length (cm)"],
        ["Absorbance definition","A = −log₁₀(T) = −log₁₀(I/I₀) = log₁₀(I₀/I)\nLogarithm base 10; sometimes natural log used (naperian) — then A_e = εₑcl"],
        ["Transmittance T","T = I/I₀  (dimensionless, 0 to 1) or %T = 100 × I/I₀\nFraction of incident light that passes through the sample"],
        ["Relationship A ↔ T","A = 2 − log₁₀(%T)\nA = 0: T = 100%; A = 1: T = 10%; A = 2: T = 1%; A = 3: T = 0.1%"],
        ["Molar attenuation coefficient ε","Intrinsic property of the absorbing molecule at a given wavelength\nUnits: L mol⁻¹ cm⁻¹  (also written M⁻¹ cm⁻¹)\nRange: 10–10⁶; large ε → strongly absorbing chromophore"],
        ["Additive absorbances","For a mixture: A_total = Σ εᵢcᵢl\nEach component contributes independently (no interaction); basis of multi-component analysis"],
        ["Bouguer/Lambert component","A ∝ l (path length); exponential attenuation per unit length\nI = I₀ e^(−αl) where α = absorption coefficient (m⁻¹ or cm⁻¹)"],
        ["Beer component","A ∝ c (concentration); each molecule absorbs independently\nBreaks down at high c due to intermolecular interactions"],
        ["Differential form","dI/I = −κ dc·dl  (κ = proportionality constant)\nIntegrating from 0 to l gives Beer-Lambert directly"],
      ]}/>

      <h2 style={S.h2}>Transmittance and Absorbance — The Logarithmic Scale</h2>
      <DiagramTAScale/>
      <Table2 rows={[
        ["Why logarithm?","Each thin layer of sample absorbs the same fraction of remaining light\nGeometric (exponential) decrease in I → logarithm converts this to linear scale"],
        ["Practical range","Most accurate measurements: A = 0.1–1.5  (T = 80% to 3%)\nBelow A = 0.1: small differences in I are noisy; above A = 1.5: too little light reaches detector"],
        ["Dilution for linearity","If A > 1.5, dilute sample to bring into linear range\nMultiply calculated c by dilution factor: c_original = c_measured × dilution"],
        ["%T vs A","%T preferred historically (analogue meter deflection); A preferred analytically\nA is directly proportional to c; %T is not — calibration curves use A"],
        ["Dynamic range","Modern instruments: A range 0–3.5 or more\nExtended using 0.1 cm microcuvettes (path length) or 10 cm cells"],
        ["Stray light limit","Stray light sets the upper limit of measurable A\nIf 0.1% stray light: maximum measurable A ≈ 3 (A = −log₁₀(0.001 + 0.001) ≈ 2.7)"],
      ]}/>

      <h2 style={S.h2}>Absorption Spectra and Chromophores</h2>
      <DiagramAbsorptionSpectrum/>
      <Table2 rows={[
        ["Absorption spectrum","Plot of A vs wavelength λ (or wavenumber ν̃)\nCharacteristic 'fingerprint' of a molecule; used for identification and purity checks"],
        ["λ_max","Wavelength of maximum absorbance; used for quantitative measurements\nAt λ_max: ε is maximum → greatest sensitivity; calibration curve steepest"],
        ["Chromophore","Part of molecule responsible for light absorption (e.g. C=O, C=C, aromatic ring)\nElectrons in chromophore undergo transitions when photon absorbed"],
        ["Auxochrome","Group attached to chromophore that shifts λ_max (bathochromic or hypsochromic)\n−OH, −NH₂ donate electrons → red-shift (bathochromic, to longer λ)"],
        ["Bathochromic shift (red shift)","λ_max moves to longer wavelength (lower energy)\nExtended conjugation, electron-donating groups, polar solvents"],
        ["Hypsochromic shift (blue shift)","λ_max moves to shorter wavelength (higher energy)\nElectron-withdrawing groups, non-polar solvents, protonation"],
        ["Hyperchromic effect","Increase in molar attenuation ε (taller peak)\nDenaturation of DNA double helix: base stacking lost → ε₂₆₀ increases ~40%"],
        ["Hypochromic effect","Decrease in ε (shorter peak)\nHelix formation in DNA or RNA; aromatic stacking reduces absorption"],
        ["Isobestic point","Wavelength where two interconverting species have equal ε\nA remains constant regardless of ratio; used to monitor equilibria cleanly"],
        ["Colour and complementary absorption","Observed colour is the complement of absorbed colour\nIf λ_max ≈ 450 nm (blue) absorbed → solution appears orange (complementary)"],
      ]}/>

      <h2 style={S.h2}>Photon Absorption — Electronic and Molecular Transitions</h2>
      <DiagramPhotonAbsorption/>
      <Table2 rows={[
        ["Photon energy condition","Absorption only when ΔE = hf = hc/λ exactly matches energy gap\nNo partial absorption; quantised transitions"],
        ["Electronic transitions (UV/Vis)","σ→σ*: deep UV (<200 nm); π→π*: UV-Vis (200–700 nm); n→π*: near-UV\nn = non-bonding electrons; * = antibonding orbital"],
        ["π→π* transitions","Conjugated systems (aromatics, dyes): low energy, visible range\nMore conjugation → longer λ_max (lower gap); basis of colour in organic dyes"],
        ["n→π* transitions","Lone pairs on O, N, S → antibonding π*; weak, forbidden\nC=O carbonyl: λ_max ≈ 270 nm, ε ≈ 15 L mol⁻¹ cm⁻¹ (weak)"],
        ["Vibrational transitions (IR)","Bond stretching and bending: 2.5–25 μm (4000–400 cm⁻¹)\nFundamental selection rule: dipole moment must change during vibration"],
        ["Rotational transitions (microwave)","Molecular rotation: cm to mm wavelength\nOnly molecules with permanent dipole moment absorb (not N₂, O₂)"],
        ["Franck-Condon principle","Electronic transitions fast compared to nuclear motion (Born-Oppenheimer)\nTransition occurs 'vertically' on energy surface → broad vibrational envelope in spectra"],
        ["Stokes shift","In fluorescence: emitted photon has lower energy than absorbed (longer λ)\nVibrational relaxation dissipates energy before emission; Stokes shift > 0"],
        ["Molar attenuation and transition","High ε (>10⁴): allowed transition; low ε (<100): forbidden or weak\nSelection rules: spin-allowed, Laporte (parity) allowed → high ε"],
      ]}/>

      <h2 style={S.h2}>Effect of Path Length</h2>
      <DiagramPathLength/>
      <Table2 rows={[
        ["Path length and A","A ∝ l (Beer-Lambert l term)\nDoubling l doubles A at constant c and ε"],
        ["Standard cuvette","l = 1 cm; most tabulated ε values assume this path length\nSemi-micro and micro cuvettes: 0.5 cm, 0.2 cm for precious samples"],
        ["Long-path cells","l = 5 or 10 cm: used for weakly absorbing solutions (e.g. dissolved gases)\nGas-phase cells: metres long using multi-pass mirrors (White cell, Herriot cell)"],
        ["Integrating sphere","Measures total diffuse transmittance of scattering samples\nLight bounces inside coated sphere; detector sees all scattered and transmitted light"],
        ["Flow cell","Continuous flow of liquid through fixed-path cuvette\nUsed in HPLC detectors, process monitoring; path length 0.2–1 cm typically"],
        ["Fibre-optic probe","Dip probe measures A in situ in a reactor or vessel\n'l' set by gap between fibre ends; no sample transfer needed"],
      ]}/>

      <h2 style={S.h2}>Deviations from Beer-Lambert Law</h2>
      <DiagramDeviations/>
      <Table2 rows={[
        ["Fundamental deviations","Beer-Lambert assumes: monochromatic light, dilute solution, no interactions\nAny violation causes non-linearity in A vs c calibration"],
        ["Polychromatic light","If bandwidth Δλ spans varying ε, apparent ε is averaged\nA vs c deviates negatively; use narrow bandwidth or λ away from sharp features"],
        ["Stray light","Light reaching detector without passing through sample (scattered, leaked, 2nd-order grating)\nCreates apparent lower A at high true A; most serious limitation at high c"],
        ["High concentration effects","Solute–solute interactions change ε; refractive index changes distort beam\nElectrolyte solutions: charged species interact → apparent ε changes with c"],
        ["Chemical equilibria","Absorbing species in equilibrium (e.g. weak acid HA ⇌ H⁺ + A⁻)\nBoth forms may absorb differently; A vs c non-linear if equilibrium shifts with c"],
        ["Fluorescence interference","Fluorescent sample emits light in detector direction → apparent high T → low apparent A\nUse right-angle geometry or fluorescence subtraction correction"],
        ["Scattering (turbidity)","Suspended particles scatter light out of beam → apparent absorbance\nTrue absorbance = measured A − scattering contribution (estimated at non-absorbing λ)"],
        ["Temperature effects","Thermal expansion changes concentration and path length slightly\nAbsorption bands shift with T; thermostat at 25°C for precise measurements"],
        ["Instrumental bandwidth","If spectral slit width > peak half-width: ε averages to lower value\nResult: A vs c sub-linear; reduce bandwidth or choose broader peak"],
      ]}/>

      <h2 style={S.h2}>Calibration Curves and Quantitative Analysis</h2>
      <Table2 rows={[
        ["Calibration curve","Plot of A vs known concentration of standard solutions\nShould be linear through origin; slope = εl; r² > 0.999 expected"],
        ["Method of standard addition","Add known amounts of analyte to the sample itself\nCompensates for matrix effects; useful for complex samples (blood, soil)"],
        ["Limit of detection (LOD)","Lowest c giving signal distinguishable from noise: LOD = 3σ_blank / slope\nσ_blank = standard deviation of blank readings"],
        ["Limit of quantification (LOQ)","LOQ = 10σ_blank / slope\nLowest c that can be reliably quantified (not just detected)"],
        ["Multi-component analysis","For mixture of n species, measure A at n wavelengths\nSolve simultaneous equations: A_λ = Σ εᵢcᵢl  (matrix method, least-squares)"],
        ["Isosbestic verification","If calibration curve is non-linear, check λ_max still valid\nUse multiple wavelengths; apply background correction"],
        ["Internal standard","Add known amount of non-interfering species to every sample and standard\nRatio sample signal / internal standard signal: removes volume and instrument drift errors"],
        ["Dilution linearity test","Measure series of dilutions; check A ∝ dilution factor\nNon-linearity confirms Beer-Lambert failure in that range"],
      ]}/>

      <h2 style={S.h2}>The Molar Attenuation Coefficient</h2>
      <Table2 rows={[
        ["Symbol and units","ε  (also written ε_M); units: L mol⁻¹ cm⁻¹  (= M⁻¹ cm⁻¹)\nSometimes given as mass attenuation: ε_m = ε / M_r  (L g⁻¹ cm⁻¹)"],
        ["Magnitude guide","ε < 100: symmetry-forbidden (n→π*); 1000–10,000: π→π* allowed\n>10,000: fully allowed transition; >100,000: strongly allowed (charge-transfer)"],
        ["Examples","Water (200 nm): ε ≈ 0.1; benzene (254 nm): ε = 204\nProtein at 280 nm: ε ≈ 10,000–100,000; DNA at 260 nm: ε ≈ 13,000 (per base-pair)\nMalachite green: ε ≈ 97,000 at 621 nm"],
        ["Determination of ε","Measure A of solution of known c in a 1-cm cell: ε = A/(cl)\nUse multiple concentrations and take slope of A vs c"],
        ["Oscillator strength","f = (4.32×10⁻⁹) ∫ ε(ν̃) dν̃  (dimensionless measure of transition probability)\nf = 1: fully allowed; f << 1: forbidden"],
        ["Extinction coefficient (older term)","Sometimes used interchangeably with ε; strictly 'extinction' includes scattering\nIUPAC recommends 'molar attenuation coefficient' for absorption-only"],
      ]}/>

      <h2 style={S.h2}>Scattering, Turbidity and Optical Density</h2>
      <Table2 rows={[
        ["Rayleigh scattering","Elastic scattering by particles much smaller than λ; I_scatter ∝ λ⁻⁴\nContributes apparent absorbance without true photon absorption"],
        ["Mie scattering","Scattering by particles comparable to λ (0.1–10 μm); less λ-dependent\nBlood cells, bacteria: Mie scattering dominates"],
        ["Turbidity (τ)","τ = −(1/l) ln(I/I₀)  (naperian); units m⁻¹ or cm⁻¹\nMeasure of particle concentration and size; used in water quality, brewing, fermentation"],
        ["Optical density (OD)","Often used interchangeably with absorbance; strictly includes all attenuation\nOD₆₀₀ (600 nm): standard measure of bacterial cell density in growth cultures"],
        ["Nephelometry","Measures scattered light at 90° rather than forward transmission\nMore sensitive than turbidimetry at very low particle concentrations"],
        ["Dynamic light scattering (DLS)","Fluctuations in scattered light intensity → particle size distribution\nMeasures hydrodynamic radius of nanoparticles, proteins, colloids"],
        ["Separating absorption from scattering","Scatter baseline estimated by fitting power law A_scatter ∝ λ⁻ⁿ to non-absorbing region\nSubtract baseline from total A to get true absorption spectrum"],
      ]}/>

      <h2 style={S.h2}>Applications of Light Absorbance</h2>
      <Table2 rows={[
        ["UV-Vis spectroscopy","Identifies aromatic compounds, conjugated systems, transition metal complexes\nQuantifies DNA/protein concentration (A₂₆₀/A₂₈₀ ratio checks purity)"],
        ["Colorimetric assays","React analyte with reagent to form coloured product; measure A at λ_max\nExamples: Bradford (protein), BCA assay, glucose oxidase (blood glucose), nitrate in water"],
        ["Atomic absorption spectroscopy (AAS)","Sample atomised in flame or graphite furnace; ground-state atoms absorb sharp lines\nElemental analysis; ppb detection of metals in blood, water, food"],
        ["HPLC-UV detection","UV absorbance detector in high-performance liquid chromatography\nMost compounds absorb at 254 nm; diode array detects full spectrum as peaks elute"],
        ["Infrared spectroscopy (IR/FTIR)","Vibrational transitions identify functional groups and molecular structure\nATR (attenuated total reflectance) measures solid and liquid samples directly"],
        ["Fluorescence spectroscopy","Measures emitted light after absorption; more sensitive than absorbance (ppb–ppt)\nFluorophore excited at λ_ex absorbs, relaxes, emits at λ_em > λ_ex (Stokes shift)"],
        ["Spectrophotometric titration","Monitor A at λ_max of product or reactant as titrant is added\nEquivalence point seen as change in slope; works for coloured species"],
        ["Remote sensing / LIDAR","Differential absorption LIDAR (DIAL): two λ; ratio gives gas concentration vs altitude\nAtmospheric CO₂, ozone, NO₂ monitoring from aircraft or satellite"],
        ["Medical diagnostics","Pulse oximetry: ratio A₆₆₀/A₉₄₀ distinguishes oxy- and deoxy-haemoglobin\nBilirubinometry: A₄₅₀ of amniotic fluid or serum for jaundice assessment"],
        ["Breweries and food industry","Colour measurement of beer, wine, oils using EBC or Lovibond scales\nMonitor fermentation progress via OD₆₀₀ of yeast cultures"],
      ]}/>

      <h2 style={S.h2}>Sources of Error in Absorbance Measurements</h2>
      <Table2 rows={[
        ["Stray light","Light reaching detector without passing through sample; limits upper A range\nTest: measure A of high-c certified absorber; deviation from expected = stray light error"],
        ["Fingerprints on cuvette","Organic contamination absorbs UV; scatters visible\nAlways handle cuvettes by frosted sides; clean with ethanol before use"],
        ["Bubbles in solution","Air bubbles scatter light → apparent high A\nDegas samples; tap cuvette gently; avoid vigorous mixing before measurement"],
        ["Incorrect blank","Using water blank for a coloured buffer solution includes buffer absorbance in sample A\nAlways blank with the same solvent/buffer as sample"],
        ["Temperature instability","Equilibrium shifts and refractive index changes affect A\nWarm samples to measurement temperature; thermostat cells if needed"],
        ["Cuvette orientation","Scratches or optical inhomogeneities in cuvette face vary reading\nAlways insert cuvette in same orientation; use matched pair of cuvettes"],
        ["Wavelength calibration","Monochromator wavelength may drift; wrong λ gives wrong ε\nCalibrate with holmium oxide glass standard (sharp known absorption peaks)"],
        ["Photometric accuracy","Detector response may be non-linear; stray light most important at high A\nVerify with NIST-traceable neutral density filters or potassium dichromate standards"],
      ]}/>

      <InfoBox title="Key Formulae — Light Absorbance" items={[
        "Beer-Lambert Law:  A = ε × c × l   (ε in L mol⁻¹ cm⁻¹, c in mol L⁻¹, l in cm)",
        "Absorbance:  A = −log₁₀(T) = −log₁₀(I/I₀) = log₁₀(I₀/I)",
        "Transmittance:  T = I/I₀  (0–1);  %T = 100 × I/I₀",
        "A ↔ %T:  A = 2 − log₁₀(%T)",
        "Additive absorbances (mixture):  A_total = Σ εᵢ cᵢ l",
        "Exponential form:  I = I₀ × 10^(−εcl) = I₀ e^(−αl)  where α = 2.303εc",
        "Absorbance from slope:  ε = slope / l  (from A vs c calibration, l in cm)",
        "Photon energy:  E = hf = hc/λ  (ΔE must match energy gap for absorption)",
        "LOD = 3σ_blank / slope;  LOQ = 10σ_blank / slope",
        "Turbidity:  τ = −(1/l) ln(I/I₀)  (naperian; units cm⁻¹)",
        "Isobestic condition:  ε_A(λ_iso) = ε_B(λ_iso)  (equal ε of two interconverting species)",
        "Stokes shift:  Δλ = λ_emission − λ_absorption  (always > 0 for fluorescence)",
      ]}/>
    </div>
  );
}